// BeneAILauncher — BeneAI-01.
//
// Replaces the main-nav ``/dashboard/beneai`` link: clicking opens
// the drawer instead of navigating away. The button looks like a
// regular sidebar nav item so the visual rhythm of the sidebar
// stays intact.

import { Sparkles } from "lucide-react";

import { useBeneAIDrawer } from "./BeneAIDrawerContext";


interface BeneAILauncherProps {
  /** Mirror the collapsed-rail behavior the other sidebar items
   *  use (icon-only, centered, label in title attr). */
  collapsed?: boolean;
  className?: string;
}


export function BeneAILauncher({
  collapsed = false, className,
}: BeneAILauncherProps) {
  const { open, openDrawer } = useBeneAIDrawer();
  return (
    <button
      type="button"
      data-testid="beneai-launcher"
      data-active={open ? "true" : "false"}
      aria-pressed={open}
      aria-label="Open BeneAI"
      title={collapsed ? "BeneAI" : undefined}
      onClick={openDrawer}
      className={[
        "relative flex w-full items-center rounded-md py-2 text-sm transition-fast ease-out",
        collapsed ? "justify-center px-2" : "gap-2.5 px-3",
        open
          ? "font-semibold text-text-primary"
          : "text-text-secondary hover:text-text-primary",
        className ?? "",
      ].join(" ")}
    >
      <span
        aria-hidden="true"
        className={[
          "absolute left-0 top-1.5 bottom-1.5 w-0.5 rounded-r-full transition-fast ease-out",
          open ? "bg-teal" : "bg-transparent",
        ].join(" ")}
      />
      {!collapsed && (
        <span
          aria-hidden="true"
          data-active-indicator={open ? "true" : "false"}
          className={[
            "inline-block h-1.5 w-1.5 rounded-full transition-fast ease-out",
            open ? "bg-teal" : "bg-transparent",
          ].join(" ")}
        />
      )}
      <Sparkles
        size={collapsed ? 18 : 16}
        className={open ? "text-text-primary" : "text-text-tertiary"}
        aria-hidden="true"
      />
      {!collapsed && <span>BeneAI</span>}
    </button>
  );
}
